/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const HeartOutline = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <g fill="#3d3d36" fillRule="nonzero">
        <path
          d="m14.6821335 9.73641731c.092155-.07979556.180978-.1648292.2662122-.25497052 1.4022057-1.4829342 1.4022057-3.89821967 0-5.38115387-1.3871931-1.46705723-3.6240624-1.46705723-5.01125547 0-.19412959.20530611-.36357127.43069192-.50669951.67275133-.19356013.32735017-.66722131.32735017-.86078144 0-.14312824-.24205941-.31256992-.46744522-.50669951-.67275133-1.38719307-1.46705723-3.6240624-1.46705723-5.01125548 0-1.40220572 1.4829342-1.40220572 3.89821967 0 5.38115387l5.94834571 6.29080681 5.5627815-5.88304475c.0284436-.05644886.0682421-.10853626.119352-.15279154zm.7059268.73549229-6.0247564 6.3716166c-.19727412.2086317-.52933368.2086317-.7266078 0l-6.3116496-6.6750269c-1.76672866-1.86844366-1.76672866-4.88681523 0-6.75525886 1.78174131-1.88432059 4.68272976-1.88432059 6.46447107 0 .07293394.07713293.14311449.15650741.21048243.23800172.06736794-.08149431.13754849-.16086879.21048243-.23800172 1.78174127-1.88432059 4.68272977-1.88432059 6.46447107 0 1.7667287 1.86844363 1.7667287 4.8868152 0 6.75525886-.0725859.0767648-.1473376.1507157-.2241521.221785-.01771.028739-.0386176.056113-.0627411.0816253z"
          transform="matrix(-1 0 0 1 18 0)"
        />
        <path
          d="m6.96906834 6.72099037c0 .27614238-.22385763.5-.5.5-.27614238 0-.5-.22385762-.5-.5 0-.55228475-.44771525-1-1-1s-1 .44771525-1 1c0 .27614238-.22385763.5-.5.5-.27614238 0-.5-.22385762-.5-.5 0-1.1045695.8954305-2 2-2s2 .8954305 2 2z"
          transform="matrix(.70710678 -.70710678 .70710678 .70710678 -2.766721 5.262524)"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default HeartOutline
